import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {HttpCallLog} from '@webmate-web-core/shared/error-handling/error-types';

@Injectable({
    providedIn: 'root'
})
export class ApiTrackingBusService {
    private readonly apiCalls$ = new Subject<HttpCallLog>();

    emit(call: HttpCallLog) {
        this.apiCalls$.next(call);
    }

    observe(): Observable<HttpCallLog> {
        return this.apiCalls$.asObservable();
    }
}
